import { FiCpu, FiBarChart2 } from "react-icons/fi";
import "./LegacyDashboard.css";
import "./GoogleAnalytics.css";

export default function AnalyticsHeader({
  gaMode,
  setGaMode,
  userProfile,
  companyDomain,
  selectedWebsite,
  gaPeriodDays = 14,
  setGaPeriodDays,
  fetchGoogleAnalyticsData,
  handleDisconnectGoogle,
  actionLoading = false,
  analyticsLoading = false,
}) {
  const handlePeriodChange = (e) => {
    const val = parseInt(e.target.value, 10);
    if (setGaPeriodDays) {
      setGaPeriodDays(val);
    }
    if (fetchGoogleAnalyticsData && userProfile?.property_id) {
      fetchGoogleAnalyticsData(
        userProfile,
        null,
        val,
        userProfile?.website,
        userProfile?.property_id
      );
    }
  };

  const propertyDisplay =
    userProfile?.ga4_property ||
    (userProfile?.property_id ? `Property #${userProfile.property_id}` : "") ||
    selectedWebsite ||
    companyDomain ||
    "None Selected";

  return (
    <div className="dashboard-card gaty-header-card p-3 p-md-4 mb-3">
      <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
        <div>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <h1 className="gaty-title-main mb-0" style={{ fontSize: "20px" }}>Google Analytics</h1>
            <span className="badge gaty-connected-badge py-1 px-2.5 d-inline-flex align-items-center gap-2 rounded-pill">
              <span className="gaty-badge-dot"></span> GA4 Connected
            </span>
          </div>
          <p className="text-muted mb-0 mt-1" style={{ fontSize: "13px" }}>
            {gaMode === "ai"
              ? "AI-powered insights from your website performance data."
              : "Live website performance metrics from your connected Google Analytics 4 property."}
          </p>
        </div>

        <div className="d-flex align-items-center gap-2.5 flex-wrap">
          {setGaMode && (
            <div className="mode-switch-slider-wrap me-2" role="group" aria-label="GA View Mode">
              <div
                className={`mode-switch-slider-bg ${
                  gaMode === "ai" ? "is-ai" : "is-legacy"
                }`}
              />
              <button
                type="button"
                className={`mode-switch-btn ${gaMode === "ai" ? "active" : ""}`}
                onClick={() => setGaMode("ai")}
                title="Switch to AI Mode"
              >
                <FiCpu size={14} />
                <span>AI Mode</span>
              </button>
              <button
                type="button"
                className={`mode-switch-btn ${gaMode === "legacy" ? "active" : ""}`}
                onClick={() => setGaMode("legacy")}
                title="Switch to Legacy Mode"
              >
                <FiBarChart2 size={14} />
                <span>Legacy</span>
              </button>
            </div>
          )}

          <span className="text-muted" style={{ fontSize: "12px", marginRight: "6px" }}>
            Property: <strong className="text-primary">{propertyDisplay}</strong>
          </span>

          <select
            className="form-select form-select-sm gaty-period-select"
            value={gaPeriodDays}
            onChange={handlePeriodChange}
            disabled={analyticsLoading}
            style={{ width: "130px", borderRadius: "6px", fontSize: "12px" }}
          >
            <option value={7}>Last 7 Days</option>
            <option value={14}>Last 14 Days</option>
            <option value={30}>Last 30 Days</option>
            <option value={60}>Last 60 Days</option>
            <option value={90}>Last 90 Days</option>
          </select>

          {handleDisconnectGoogle && (
            <button
              className="btn btn-outline-danger btn-sm fw-semibold"
              style={{ borderRadius: "6px", fontSize: "12px" }}
              onClick={handleDisconnectGoogle}
              disabled={actionLoading}
            >
              Disconnect
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
